import React from "react";
import {
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Divider,
  Menu,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { MoreVert } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  filterRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 16,
    padding: "8px 0 16px 0",
  },
  filterSearch: {
    flex: "1 1 auto",
  },
  primaryClamp2: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
}));

export default function QuizList({
  list,
  searchText,
  onSearchChange,
  menuAnchorEl, // { el, quizId } | null
  onOpenMenu,
  onCloseMenu,
  onEditClick,
  onDeleteClick,
}) {
  const classes = useStyles();

  return (
    <>
      {/* barra di ricerca */}
      <Box className={classes.filterRow}>
        <Box className={classes.filterSearch}>
          <TextField
            label="Cerca quiz"
            variant="standard"
            margin="dense"
            fullWidth
            value={searchText}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </Box>
      </Box>

      {/* lista quiz */}
      <List>
        {list.map((item, idx) => (
          <React.Fragment key={item.id}>
            {idx > 0 && <Divider component="li" />}
            <ListItem>
              <ListItemText
                primary={item.name}
                primaryTypographyProps={{ className: classes.primaryClamp2 }}
                secondary={item.description}
              />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  aria-label="menu"
                  onClick={(e) =>
                    onOpenMenu({ el: e.currentTarget, quizId: item.id })
                  }
                >
                  <MoreVert />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </React.Fragment>
        ))}
      </List>

      <Menu
        anchorEl={menuAnchorEl?.el || null}
        open={Boolean(menuAnchorEl)}
        onClose={onCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            onEditClick(menuAnchorEl.quizId);
            onCloseMenu();
          }}
        >
          Modifica
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDeleteClick(menuAnchorEl.quizId);
            onCloseMenu();
          }}
        >
          Elimina
        </MenuItem>
      </Menu>
    </>
  );
}
